import RoleColorSelect from "./role-color-select";


const RoleFormItems = {
    ColorSelect: RoleColorSelect,
};

export default RoleFormItems;
